import { NotificationPreferences } from "./NotificationPreferences";

export function Preferences() {
  return <NotificationPreferences />;
}
